import { Dialog, DialogBody, DialogTitle } from "V2.0/common/dialog";
import Form from "V2.0/components/Form";
import { DialogTitleWithClose } from "V2.0/HomePages/HomeModule/CustomAPIs/components/Dialog/DialogTitleWithClose";
import { message } from "antd";
import { useMemo, useState } from "react";
import { updateContact } from "..";

import { fieldTemplate, fieldSchema } from "../models/template";
import { showErrorToast } from "V2.0/utils/showErrorToast";

export function EditContact(props) {
  const { fetchContacts, projectId, contact, open, onClose } = props;

  const inputFields = useMemo(() => {
    const { firstName, lastName, email, phone } = contact;

    return {
      firstName,
      lastName,
      email,
      phone,
    };
  }, [contact]);

  const [loading, setLoading] = useState(false);
  const onDialogClose = () => {
    onClose();
    setLoading(false);
  };

  const onSubmit = async (data) => {
    const payload = {
      contact: data,
    };

    try {
      const response = await updateContact({
        projectId,
        contactId: contact._id,
        payload,
      });

      if (response.status === 200) {
        message.success("Contact updated");
        fetchContacts(projectId);
        onDialogClose();
      }
    } catch (error) {
      showErrorToast(error, "Failed to udpate contact");
    }
  };

  return (
    <>
      {open && (
        <Dialog open={open} onClose={() => {}}>
          <DialogTitle>
            <DialogTitleWithClose
              title="Edit Contact"
              onClose={onDialogClose}
            />
          </DialogTitle>
          <DialogBody>
            <Form
              template={fieldTemplate}
              inputField={inputFields}
              schema={fieldSchema}
              onSubmit={onSubmit}
              handleSecondary={onDialogClose}
              buttonInfo={{
                buttons: "2",
                primaryLabel: "Update",
                secondaryLabel: "Cancel",
              }}
              loading={loading}
              setLoading={setLoading}
              errorMessage={{}}
            />
          </DialogBody>
        </Dialog>
      )}
    </>
  );
}
